import { useMutation } from "react-query";
import { getIdentity } from "../actions/clients";
import AppSettings from "../config";
import useNetworkHeaders from "../hooks/useNetworkHeaders";
import { useHistory } from "react-router";
import useSite from "../features/permits/components/inspections/InspectionPanel/useSite";

export const fetchGetIdentity = (dispatch: any) => () => dispatch(getIdentity());

export const useUserDelete = () => {
  const history = useHistory();
  const site = useSite();
  const headers = useNetworkHeaders();
  const [deleteUser, { isLoading }] = useMutation(userDelete(headers));
  return {
    deleteUser: async () => {
      const response = await deleteUser();
      history.push(`/${site}/logout`);
      return response;
    },
    isLoading: isLoading,
  };
};

const userDelete = (headers: any) => {
  return async () => {
    const response = await fetch(`${AppSettings.IDENTITY_API_URL}/me`, {
      method: "DELETE",
      headers: headers,
    });
    return await response.json();
  };
};
